import React from 'react';
import { Trans } from 'react-i18next';
import { RadioGroupProps, RadioOption } from './types';

const RadioGroupV2: React.FC<RadioGroupProps> = (props: RadioGroupProps) => {
  return (
    <div className="flex flex-col gap-3">
      {props.label && (
        <div className="text-sm text-[#1A1A1A] font-medium">
          <Trans i18nKey={props.label} />
        </div>
      )}
      <div
        className={`flex ${props.horizontal ? 'flex-row' : 'flex-col'} gap-6`}
      >
        {props.options.map((option: RadioOption) => (
          <div key={option.value} className="flex items-start">
            <div className="flex items-center h-5 mt-1">
              <input
                id={`${props.name}-${option.value}`}
                name={props.name}
                type="radio"
                checked={props.value === option.value}
                onChange={() => props.onChange(option.value)}
                disabled={props.disabled}
                className={`
                  appearance-none w-5 h-5 rounded-full cursor-pointer transition-all duration-200
                  bg-white border-[5px] border-transparent ring-1 ring-gray-300
                  checked:bg-[#561BDC] checked:border-white checked:ring-[#A3A7FF]
                  focus:outline-none
                  ${props.disabled ? 'opacity-50 cursor-not-allowed' : ''}
                `}
              />
            </div>
            <div className="ml-3 text-sm">
              <label
                htmlFor={`${props.name}-${option.value}`}
                className="font-medium text-gray-700 cursor-pointer"
              >
                {option.label}
              </label>
              {option.description && (
                <p className="text-gray-500 mt-1 max-w-[200px]">
                  {option.description}
                </p>
              )}
            </div>
          </div>
        ))}
      </div>
      {props.errorMessage && (
        <div className="text-red-500 text-xs mt-1">{props.errorMessage}</div>
      )}
    </div>
  );
};

export default RadioGroupV2;
